export default __webpack_public_path__ + "static/media/subscription-active.734aafec.svg";